<template>
  <el-container>
    <Loader/>

    <el-main>
      <div class="login">
        <el-row>
          <el-col
              :xs="{ span: 20, offset: 2 }"
              :sm="{ span: 14, offset: 5 }"
              :md="{ span: 10, offset: 7 }"
              :lg="{ span: 8, offset: 8 }"
              :xl="{ span: 6, offset: 9 }"
          >
            <div class="login__logo">
              <Logo/>
            </div>

            <el-form :model="form" :rules="rules" ref="form" label-width="90px">
              <el-form-item label="帳號" prop="username">
                <el-input
                    placeholder="請輸入空英會員帳號"
                    v-model="form.username"
                    :disabled="loading"
                    :autofocus="true"
                    @keyup.enter.native="submitForm"></el-input>
              </el-form-item>

              <el-form-item label="密碼" prop="password">
                <el-input
                    type="password"
                    placeholder="請輸入密碼"
                    v-model="form.password"
                    :disabled="loading"
                    @keyup.enter.native="submitForm"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                    type="primary"
                    :disabled="loading || form.username === '' || form.password === ''"
                    @click.prevent.stop="submitForm"
                >
                  登入
                </el-button>
		<!--
                <el-button
                    type="primary"
                    @click.prevent.stop="authFacebook"
                >
                  FB登入
                </el-button>
                -->

                <HowTo/>
              </el-form-item>
              <el-form-item>
                <BrowserSupport/>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {rules} from '@/helpers/loginForm'
import Loader from '@/components/Loader'
import Logo from '@/components/Logo'
import HowTo from '@/components/login/HowTo'
import BrowserSupport from '@/components/login/BrowserSupport'
//import qs from "qs";
//import axios from "axios";

export default {
  components: {
    Loader,
    Logo,
    HowTo,
    BrowserSupport
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: rules,
      profile: {},
      authorized: false
    }
  },
  computed: {
    ...mapGetters({
      loading: 'loading/loading'
    })
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      fbLogin: 'auth/fbLogin',
      notify: 'notification/notify'
    }),
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.beforeLogin()
        } else {
          return false
        }
      })
    },
    authFacebook() {
      let vm = this
      FB.login(function (response) {
        vm.getProfile();
      }, {
        scope: 'email, public_profile',
        return_scopes: true
      });
    },
    getProfile() {
      let vm = this
      FB.api('/me?fields=name,id,email', function (response) {
        vm.$set(vm, 'profile', response)
        vm.beforefbLogin();
      })
    },
    async beforefbLogin() {
      try {
        await this.fbLogin({
          payload: {
            id: this.profile.id,
          },
          context: this
        })

        this.$router.replace({name: 'home'})

      } catch(error) {
        this.notify({context: this, error: error})
      }
    },
    async beforeLogin() {
    try {
      await this.login({
        payload: {
          username: this.form.username,
          password: this.form.password
        },
        context: this
      })

      this.$router.replace({name: 'home'})

    } catch(error) {
      this.form.password = ''
      this.$refs['form'].validate()

      this.notify({context: this, error: error})
    }
  }
}
}
</script>

<style lang="sass" scoped>
.login
  margin-top: 12vh

.el-container
  background-color: #ffecb3
</style>
